import { useTheme } from '@src/theme';
import { ReactNode } from 'react';

interface ReusableCardProps {
    title: ReactNode;
    icon: ReactNode;
    content: ReactNode;
    className?: string;
    contentClassName?: string;
}

export const Card = ({
    title,
    icon,
    content,
    className = '',
    contentClassName = '',
}: ReusableCardProps) => {
    const { theme } = useTheme();
    return (
        <div
            className={`bg-light-gray rounded-2xl shadow-md ${className}`}
            style={{ backgroundColor: theme.semantic.background }}
        >
            <div
                className="flex gap-3 items-center p-4 rounded-2xl"
                style={{
                    backgroundColor: theme.semantic.infoContainerLight,
                    color: theme.semantic.textPrimary,
                }}
            >
                <div className="border flex items-center justify-center w-10 h-10 rounded-lg border-primary-light">
                    {icon}
                </div>
                <div className="font-semibold text-M-20">{title}</div>
            </div>

            <div className={`py-6 ${contentClassName}`}>{content}</div>
        </div>
    );
};
